import { createContext, useContext } from 'react'

/** Was eine Zeile an den Aufgaben-Details ihrer Seite auslösen darf. */
export interface TaskDetailsOpener {
  /**
   * Öffnet die Details auf „Kommentare" (#183) — die **Marke** an der Zeile. Mit `parentId` ist
   * `taskId` eine Unteraufgabe dieser Aufgabe (aufgeklappte Karte).
   */
  openComments: (taskId: string, parentId?: string) => void
  /**
   * Öffnet die Details mit offenem Chip „Erinnerung“ — die Glocke an der Zeile und „Datum &
   * Uhrzeit …“ im Aufgaben-Menü (Plan task-reminders). `parentId` wie bei `openComments`; mit
   * `tab: 'at'` steht der Chip gleich beim Anlegen auf „Datum & Uhrzeit“ (der Menüeintrag).
   */
  openReminders: (taskId: string, parentId?: string, tab?: 'at') => void
}

const TaskDetailsOpenerContext = createContext<TaskDetailsOpener | null>(null)

/**
 * **Nur Seiten mit Aufgaben-Details bieten ihn an** (Projekt, Kurz notiert, Demnächst; über
 * `useTaskDetailsPane().opener`). Ohne ihn ist die Marke an der Zeile nur Anzeige — ein Knopf, der
 * nichts öffnen kann, wäre schlechter als keiner.
 */
export const TaskDetailsOpenerProvider = TaskDetailsOpenerContext.Provider

export function useTaskDetailsOpener(): TaskDetailsOpener | null {
  return useContext(TaskDetailsOpenerContext)
}
